export interface IBrowserInfo {
  readonly name: string
  readonly version: string
}

export function detectBrowser(): IBrowserInfo {
  const ua = navigator.userAgent

  if (/Edg\/(\d+(?:\.\d+)*)/.test(ua)) {
    return { name: 'Edge', version: RegExp.$1 }
  }
  if (/Chrome\/(\d+(?:\.\d+)*)/.test(ua) && !/Edg\//.test(ua)) {
    return { name: 'Chrome', version: RegExp.$1 }
  }
  if (/Firefox\/(\d+(?:\.\d+)*)/.test(ua)) {
    return { name: 'Firefox', version: RegExp.$1 }
  }
  if (/Version\/(\d+(?:\.\d+)*).*Safari/.test(ua)) {
    return { name: 'Safari', version: RegExp.$1 }
  }
  if (/(?:MSIE |rv:)(\d+(?:\.\d+)*)/.test(ua)) {
    return { name: 'IE', version: RegExp.$1 }
  }

  return { name: 'Unknown', version: 'Unknown' }
}
